import { render, staticRenderFns } from "./act004-quiz-image-option-overlay.vue?vue&type=template&id=0c474335&scoped=true"
import script from "./act004-quiz-image-option-overlay.vue?vue&type=script&lang=js"
export * from "./act004-quiz-image-option-overlay.vue?vue&type=script&lang=js"
import style0 from "./act004-quiz-image-option-overlay.vue?vue&type=style&index=0&id=0c474335&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c474335",
  null
  
)

export default component.exports